import { Close } from '@mui/icons-material';
import {
  Backdrop,
  Button,
  CircularProgress,
  Fade,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
} from '@mui/material';
import { Box } from '@mui/system';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setNotification } from 'redux/notifications/ducks';

const SortModal = ({
  open,
  handleSort,
  fetchFleetVehicle,
  classes,
  handleClose,
  sortParams,
  isLoading,
}) => {
  const [thisSortParams, setThisSortParams] = React.useState(sortParams);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const confirmHandler = async () => {
    const response = await fetchFleetVehicle();
    setThisSortParams(sortParams);
    response === 200 && handleClose();
    response !== 200 &&
      dispatch(
        setNotification('An error has occurred, Try Again', 'error', true)
      );
  };
  let btnIsDisabled =
    isEqual(thisSortParams, sortParams) ||
    !sortParams?.order_by ||
    !sortParams?.sort_by ||
    isLoading;

  return (
    <Modal
      className={classes.modal}
      open={open}
      slots={Backdrop}
      slotProps={{
        timeout: 500,
      }}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Paper
          className={classes.paper}
          style={{ width: '480px' }}
          data-hook='sort-modal'
        >
          <IconButton style={{ alignSelf: 'flex-end' }} onClick={handleClose}>
            <Close />
          </IconButton>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              justifyContent: 'center',
              gap: '20px',
              marginBottom: '3rem',
            }}
          >
            <Box sx={{ minWidth: 120 }}>
              <FormControl variant='filled' fullWidth>
                <InputLabel id='demo-simple-select-outlined-label'>
                  {t('fleetsSection.sortBy')}
                </InputLabel>
                <Select
                  required
                  name='sort_by'
                  labelId='demo-simple-select-outlined-label'
                  id='demo-simple-select-outlined'
                  value={sortParams?.sort_by}
                  onChange={handleSort}
                  label='sort by'
                  variant='standard'
                  data-hook='sortBy-field'
                >
                  <MenuItem value='name'>
                    {t('fleetsSection.vehicleName')}
                  </MenuItem>
                  <MenuItem value='reg_plate'>
                    {t('fleetsSection.regNumber')}
                  </MenuItem>
                  <MenuItem value='mounted_tires' data-hook='mounted_tires'>
                    {t('fleetsSection.mountedTires')}
                  </MenuItem>
                  <MenuItem value='safety_check_date'>
                    {t('singleVehicleUpload.safetyCheckLabel')}
                  </MenuItem>
                  <MenuItem value='inspection_date'>
                    {t('singleVehicleUpload.inspectionDateLabel')}
                  </MenuItem>
                  <MenuItem value='uvv_check_date'>
                    {t('vehiclePage.uvvCheck')}
                  </MenuItem>
                  <MenuItem value='telematics_protocol'>
                    {t('common.integrationInfo')}
                  </MenuItem>
                  <MenuItem value='axle_type'>
                    {t('fleetsSection.axleType')}
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ minWidth: 120 }}>
              <FormControl variant='filled' fullWidth>
                <InputLabel id='demo-simple-select-outlined-label'>
                  {t('fleetsSection.orderBy')}
                </InputLabel>
                <Select
                  required
                  name='order_by'
                  labelId='demo-simple-select-outlined-label'
                  id='demo-simple-select-outlined'
                  value={sortParams?.order_by}
                  onChange={handleSort}
                  label='order:'
                  variant='standard'
                  data-hook='order-field'
                >
                  <MenuItem value='ASC'>{t('fleetsSection.asc')}</MenuItem>
                  <MenuItem value='DESC' data-hook='desc'>
                    {t('fleetsSection.desc')}
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Button
              sx={{ textTransform: 'unset' }}
              onClick={confirmHandler}
              variant='contained'
              disabled={btnIsDisabled}
              data-hook='sort-btn'
            >
              {isLoading ? (
                <CircularProgress size={24} />
              ) : (
                t('fleetsSection.sort')
              )}
            </Button>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default SortModal;

SortModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleSort: PropTypes.func.isRequired,
  fetchFleetVehicle: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  sortParams: PropTypes.shape({
    order_by: PropTypes.string,
    sort_by: PropTypes.string,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
};
